import { Component } from '@angular/core';

@Component({
  selector: 'fgb-payment-navbar',
  templateUrl: './payment-navbar.component.html',
  styleUrl: './payment-navbar.component.scss',
})
export class PaymentNavbarComponent {}
